<ng-content *ngIf="enabled"></ng-content>

<ng-container *ngIf="!enabled">
  <rt-sidebar-item
    type="heading"
    [name]="name"
    [icon]="icon"
    [href]="href"
    [rightOutlet]="rightIcon"
    [attr.margin-bottom-small-x]="addMargin"
  ></rt-sidebar-item>
</ng-container>

<ng-template #rightIcon>
  <rt-icon name="upgrade" colorToken="colorIconScaleDefault"></rt-icon>
</ng-template>
